import { useContext, useEffect, useState } from "react";
import { DropdownsContext } from "../../../../contexts/DropdownsContext";
import "./OrderDetailInfo.css";
import Dropdowns from "../../../../components/Dropdowns/Dropdowns";
import Skeleton from "react-loading-skeleton";
import Input from "../../../../components/Inputs/Input";
import CheckboxField from "../../../../components/Checkbox/CheckboxField";
import BasicDatePicker from "../../../../components/Datepicker/Datepicker";
import { NewOrderContext } from "../../context/NewOrderContext";
import { OrderManagementContext } from "../../../StoresModule/context/OrderManagementContext";

const OrderDetailInfo = ({
  item,
  onChangeItem,
  context = "new_order",
  disable = false,
  currencyName,
  orderOriginalCost,
  fromQuote,
  vendorParentId,
}) => {
  const dropdownIds = [75, 96, 34, 123];
  const dropdownNames = {
    75: "partNumber",
    96: "partCondition",
    34: "owner",
    123: "sourceOfPrice",
    124: "quotation",
    125: "contract",
  };
  const requiredFields = {
    partNumber: true,
    partCondition: true,
    owner: true,
  };
  const defaultDetailInformation =
    context == "new_order"
      ? {
          partNumber: "",
          partCondition: 1,
          owner: null,
          orderQty: "",
          freeOfCharge: false,
          minQTY: 0,
          unitCost: fromQuote ? item.unit_cost : "0",
          discount: fromQuote ? item.discount_applied : "0",
          discountPercentage: fromQuote
            ? (item?.discount_applied /
                (item.unit_cost * item.quantity_order)) *
              100
            : "0",
          duty: "0",
          freightCost: "0",
          tax: fromQuote ? item.tax_included : "0",
          taxPercentage: fromQuote
            ? (item?.tax_included / (item.unit_cost * item.quantity_order)) *
              100
            : "0",
          estDeliveryDate: fromQuote ? item.est_delivery_date : null,
          capitalExpenditure: "",
          warrantyHours: "",
          warrantyCycles: "",
          warrantyCalendarDays: "",
          warrantyAircraftDays: "",
          warrantyLatest: false,
          quote_id: fromQuote ? item.quote_id : null,
          companyId: "",
          sourceOfPrice: fromQuote ? "Use Quote" : "Enter Price Manually",
        }
      : context == "order_management"
      ? {
          partId: null,
          partConditionId: 1,
          // owner: null,
          quantityOrder: "",
          freeOfCharge: false,
          minQTY: 0,
          unitPrice: "0",
          // discount: "0",
          discountPercentage: "0",
          duty: "0",
          freightCost: "0",
          tax: "0",
          // taxPercentage: "0",
          estDeliveryDate: null,
          capitalExpenditure: "",
          warrantyHours: "",
          warrantyCycles: "",
          warrantyCalendarDays: "",
          warrantyAircraftDays: "",
          warrantyLatest: false,
        }
      : null;

  const {
    dropdownsData,
    setDropdownsData,
    setDropdownIds,
    dropdownDefaultOptions,
  } = useContext(DropdownsContext);

  // if (context == "new_order") {
  //   const { lineNumberInfo, setLineNumberInfo, generalInfo } =
  //     useContext(NewOrderContext);

  // }

  const newOrderContext = useContext(NewOrderContext);
  const lineNumberInfo = newOrderContext?.lineNumberInfo;
  const setLineNumberInfo = newOrderContext?.setLineNumberInfo;
  const vendorLineNumberInfoList = newOrderContext?.vendorLineNumberInfoList;
  const setVendorLineNumberInfoList =
    newOrderContext?.setVendorLineNumberInfoList;
  const generalInfo = newOrderContext?.generalInfo;

  const [displayForm, setDisplayForm] = useState(false);
  const matchingLineInfo = fromQuote
  ? vendorLineNumberInfoList?.find((entry) => entry.vendorParentId === vendorParentId)
  : null;

const lineNumber = fromQuote
  ? matchingLineInfo?.lineNumberInfo?.[item.line_number]
  : lineNumberInfo?.[item.line_number];

const lineInfo = lineNumber;

const [defaults, setDefaults] = useState({
  ...defaultDetailInformation,
  ...lineInfo,
  partNumber: item.id,
  companyId: item.company_id,
  uomId: item.uom_id,
});

const [values, setValues] = useState({
  ...defaultDetailInformation,
  ...lineInfo,
  partNumber: item.id,
  companyId: item.company_id,
  uomId: item.uom_id,
});
  const [errorState, setErrorState] = useState({});
  const [subTotalCost, setSubTotalCost] = useState(0);
  const [totalCost, setTotalCost] = useState(0);

  const [selectionMode, setSelectionMode] = useState(
    fromQuote ? "Use Quote" : "Enter Price Manually"
  );
  const [quotation, setQuotation] = useState(null);
  const [contract, setContract] = useState(null);
  const [prnInfo, setPrnInfo] = useState(
    context == "new_order" ? item.prn_info : item?.partRequest || []
  );
  const [companyParameter, _] = useState([
    { columnName: "companyId", value: localStorage.getItem("u_company_id") },
  ]);

  useEffect(() => {
    if (dropdownsData && dropdownsData.length > 0) {
      setDisplayForm(true);
    }
  }, [dropdownsData]);

  useEffect(() => {
    if (fromQuote) {
      setVendorLineNumberInfoList((prev) => {
        const newList = [...prev];
        const existingIndex = newList.findIndex(
          (item) => item.vendorParentId === vendorParentId
        );

        if (existingIndex !== -1) {
          newList[existingIndex] = {
            vendorParentId,
            lineNumberInfo,
          };
        } else {
          newList.push({
            vendorParentId,
            lineNumberInfo,
          });
        }

        return newList;
      });
    }
  }, [lineNumberInfo]);

  useEffect(() => {
    const subTotalCost =
      context == "new_order"
        ? values.orderQty * values.unitCost
        : values.quantityOrder * values.unitPrice;

    const totalCost =
      subTotalCost -
      (values.discount ? parseInt(values.discount) : 0) +
      (values.freightCost ? parseInt(values.freightCost) : 0) +
      (values.duty ? parseInt(values.duty) : 0) +
      (values.tax ? parseInt(values.tax) : 0);

    setTotalCost(totalCost);
    setSubTotalCost(subTotalCost);
    context == "new_order" &&
      setLineNumberInfo((prev) => ({
        ...prev,
        [item.line_number]: { ...values, totalCost, subTotalCost, prnInfo },
      }));

    context == "order_management" &&
      setLineNumberInfo((prev) => {
        let updatedData = [];
        prnInfo.map((prn, idx) => {
          let totalRequired = 0;

          prnInfo.map((prn) => {
            totalRequired += parseInt(prn.partRequestDetailParts.length);
          });

          let remainingQty = parseInt(values.quantityOrder) - totalRequired;

          let quantityOrder = parseInt(prn.partRequestDetailParts.length);

          if (idx == 0) {
            quantityOrder += remainingQty;
          }
          updatedData.push({
            ...values,
            totalCost,
            subTotalCost,
            id: prn.originalDetailId,
            partId: item.partId,
            version: item.version,
            lineNumber: item.lineNumber,
            uomId: item.uomId,
            companyId: item.companyId,
            orderId: item.orderId,
            status: item.status,
            partRequest: { id: prn.id },
            quantityOrder: quantityOrder,
          });
        });

        return updatedData;
      });
  }, [values]);

  // useEffect(() => {
  //   if (context == "order_management") {
  //     setOrderTotalCost({
  //       orderId: item.orderId,
  //       totalCost: totalCost,
  //     })
  //   }
  // }, [totalCost])

  const [previousPartCost, setPreviousPartCost] = useState(null);
  const orderContext = useContext(OrderManagementContext);
  const setOrderTotalCost =
    context === "order_management" ? orderContext.setOrderTotalCost : null;

  useEffect(() => {
    if (context == "order_management") {
      const subTotalCost = item?.quantityOrder * item?.unitPrice;
      const discountAmount = (subTotalCost / 100) * item?.discountPercentage;

      const initialCost =
        subTotalCost -
        (discountAmount ? parseInt(discountAmount) : 0) +
        (item.freightCost ? parseInt(item?.freightCost) : 0) +
        (item?.duty ? parseInt(item?.duty) : 0) +
        (item?.tax ? parseInt(item?.tax) : 0);

      setPreviousPartCost(initialCost);
    }

    setDropdownIds(dropdownIds);
  }, []);

  useEffect(() => {
    if (
      context === "order_management" &&
      orderOriginalCost &&
      previousPartCost != null
    ) {
      if (totalCost !== previousPartCost && !disable) {
        const newOrderCost = orderOriginalCost - previousPartCost + totalCost;

        setOrderTotalCost({
          orderId: item.orderId,
          totalCost: newOrderCost,
        });
      }
    }
  }, [totalCost]);

  // const handleDropdownValue = (value, name, data) => {
  //   changeValue({ target: { name, value: value[data], completeValue: value } });

  //   setDefaults((prev) => ({
  //     ...prev,
  //     ...{ [name]: " " },
  //   }));
  // };

  const handleDropdownValue = (value, name, data) => {
    const fieldName =
      context === "order_management" && name === "owner" ? "ownerId" : name;

    changeValue({
      target: {
        name: fieldName,
        value: value[data],
        completeValue: value,
      },
    });

    setDefaults((prev) => ({
      ...prev,
      ...{ [fieldName]: " " },
    }));
  };

  const changeValue = (e) => {
    const { name, value, completeValue } = e.target;
    if (name in requiredFields) {
      setErrorState((prev) => ({
        ...prev,
        [name]: value || completeValue ? "" : "Required",
      }));
    }

    let updatedValues = { ...values, [name]: value };
    switch (name) {
      case "unitPrice":
        {
          const subTotalCost =
            context == "new_order"
              ? values.orderQty * value
              : values.quantityOrder * value;

          if (values.discountPercentage > 0) {
            const discountAmount =
              (subTotalCost / 100) * values.discountPercentage;
            updatedValues.discount = discountAmount;
          }

          if (value.taxPercentage) {
            const taxAmmount = (subTotalCost / 100) * value.taxPercentage;
            updatedValues.tax = taxAmmount;
          }
        }
        break;
      case "unitCost":
        {
          const subTotalCost =
            context == "new_order"
              ? values.orderQty * value
              : values.quantityOrder * value;
          if (values.discountPercentage > 0) {
            const discountAmount =
              (subTotalCost / 100) * values.discountPercentage;
            updatedValues.discount = discountAmount;
          }

          if (value.taxPercentage) {
            const taxAmmount = (subTotalCost / 100) * value.taxPercentage;
            updatedValues.tax = taxAmmount;
          }
        }
        break;
      case "discountPercentage":
        if (subTotalCost > 0) {
          const discountAmount = (subTotalCost / 100) * value;
          updatedValues.discount = discountAmount;
        }
        break;
      case "partCondition":
        updatedValues.partConditionName = completeValue.name;
        break;
      case "discount":
        if (subTotalCost > 0) {
          const percentage = (value / subTotalCost) * 100;
          updatedValues.discountPercentage = percentage.toFixed(0);
        }
        break;
      case "taxPercentage":
        if (subTotalCost > 0) {
          const taxAmmount = (subTotalCost / 100) * value;
          updatedValues.tax = taxAmmount;
        }
        break;

      case "tax":
        if (subTotalCost > 0) {
          const taxPercentage = (value / subTotalCost) * 100;
          updatedValues.taxPercentage = taxPercentage.toFixed(0);
        }
        break;
    }

    setValues(updatedValues);
  };

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };
  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };
  const handleSelectAll = (checked, name) => {
    setValues((prev) => {
      return {
        ...prev,
        ...{ [name]: checked },
      };
    });
  };
  const changeValueDate = (newValue, name) => {
    const completeValue = newValue?.format("MM-DD-YYYY");
    context == "new_order"
      ? setValues((prev) => {
          return {
            ...prev,
            ["orginalDate"]: newValue,
            ...{ [name]: completeValue },
          };
        })
      : context == "order_management"
      ? setValues((prev) => {
          return {
            ...prev,
            ["orginalDate"]: newValue,
            ...{ [name]: newValue },
          };
        })
      : "";
  };

  const onDeletePrn = (idx, item) => {
    const updatedPrnInfo = prnInfo.filter((_, index) => index !== idx);
    const minValue = updatedPrnInfo
      .map((prn) => prn.quantity_required)
      .reduce((a, b) => parseInt(a) + parseInt(b), 0);
    let minQTY = minValue;

    setValues((prev) => ({
      ...prev,
      minQTY,
    }));
    setLineNumberInfo((prev) => ({
      ...prev,
      [item.line_number]: { ...prev[item.line_number], minQTY, prnInfo },
    }));

    setPrnInfo(updatedPrnInfo);
  };
  const enableEdition = (idx, item, isOnEdition) => {
    prnInfo[idx].isOnEdition = isOnEdition;

    setPrnInfo([...prnInfo]);
  };
  const changeValuePrn = (e, idx) => {
    const { value } = e.target;
    context == "new_order"
      ? (prnInfo[idx].quantity_required = value)
      : context == "order_management"
      ? (prnInfo[idx].quantityOrder = value)
      : null;
    setPrnInfo([...prnInfo]);
  };

  useEffect(() => {
    if (context == "new_order") {
      if (values) {
        const minValue = prnInfo
          .map((prn) => prn.quantity_required)
          .reduce((a, b) => parseInt(a) + parseInt(b), 0);
        if (values.orderQty < minValue) {
          let updatedValues = {
            ...values,
            ["minQTY"]: minValue,
            ["orderQty"]: minValue,
          };
          setValues(updatedValues);
        } else {
          let updatedValues = {
            ...values,
            ["minQTY"]: minValue,
          };

          setValues(updatedValues);
        }
      }
      setLineNumberInfo((prev) => ({
        ...prev,
        [item.line_number]: { ...prev[item.line_number], prnInfo },
      }));
    } else if (context == "order_management") {
      if (values) {
        const minValue = prnInfo
          .map((prn) => prn.quantityOrder)
          .reduce((a, b) => parseInt(a) + parseInt(b), 0);

        const subTotalCost = item?.quantityOrder * item?.unitPrice;
        const discountAmount = (subTotalCost / 100) * item?.discountPercentage;
        const taxPercentage = (item?.tax / subTotalCost) * 100;

        const correctedQuantity =
          item?.quantityOrder < minValue ? minValue : item?.quantityOrder;

        const new_data = {
          partId: null,
          partConditionId: 1,
          ownerId: item?.ownerId,
          quantityOrder: correctedQuantity,
          freeOfCharge: item?.freeOfCharge,
          minQTY: minValue,
          unitPrice: item?.unitPrice,
          discount: discountAmount,
          discountPercentage: item?.discountPercentage,
          duty: item?.duty,
          freightCost: item?.freightCost,
          tax: item?.tax,
          taxPercentage: taxPercentage,
          estDeliveryDate: item?.estDeliveryDate,
          capitalExpenditure: item?.capitalExpenditure,
          warrantyHours: item?.warrantyHours,
          warrantyCycles: item?.warrantyCycles,
          warrantyCalendarDays: item?.warrantyCalendarDays,
          warrantyAircraftDays: item?.warrantyAircraftDays,
          warrantyLatest: item?.warrantyLatest,
        };

        setValues(new_data);
      }
    }
  }, [prnInfo]);

  return (
    <div className="order-detail-info-full-container">
      <div className="order-purchase-info">
        <h4>Purchase Info</h4>
        <div className="order-purchase-row1">
          {displayForm ? (
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              disabled={true}
              required={true}
              key={75}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[75], data)
              }
              error={errorState[dropdownNames[75]]}
              hideRequiredLabel={true}
              parameters={companyParameter}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 75)}
              preSelectValue={item.id}
            />
          ) : (
            <Skeleton height="2rem" width="80%" />
          )}
          {displayForm ? (
            <div className="order-quantity-req">
              <Input
                style={{ gridColumn: "span 1" }}
                onChange={changeValue}
                name={
                  context == "new_order"
                    ? "orderQty"
                    : context == "order_management"
                    ? "quantityOrder"
                    : ""
                }
                disableAutocomplete={true}
                minValue={values["minQTY"]}
                isNumeric={true}
                label={"Order QTY"}
                disabled={disable || fromQuote}
                value={
                  context == "new_order"
                    ? values["orderQty"]
                    : values["quantityOrder"]
                }
              />
              <b>{item.uom_abrevation}</b>
            </div>
          ) : (
            <Skeleton height="2rem" width="100%" />
          )}
          {displayForm ? (
            <Dropdowns
              context={{
                dropdownsData,
                setDropdownsData,
                setDropdownIds,
                dropdownDefaultOptions,
              }}
              updateDropdown={updateDropdown}
              resetDropdownsReload={resetDropdownsReload}
              disabled={disable || fromQuote}
              required={true}
              key={96}
              onOptionSelect={(value, data) =>
                handleDropdownValue(value, dropdownNames[96], data)
              }
              error={errorState[dropdownNames[96]]}
              hideRequiredLabel={true}
              parameters={companyParameter}
              showPagination={false}
              data={dropdownsData.find((e) => e.id === 96)}
              preSelectValue={
                context == "new_order"
                  ? defaults?.[dropdownNames[96]]
                  : defaults?.["partConditionId"]
              }
            />
          ) : (
            <Skeleton height="2rem" width="100%" />
          )}
          {displayForm ? (
            <CheckboxField
              disabled={disable || fromQuote}
              outlined
              checked={
                context == "new_order"
                  ? values.freeOfCharge
                  : values.freeOfCharge
              }
              onChange={(checked) => handleSelectAll(checked, "freeOfCharge")}
            >
              <span>Free of Charge (FOC)</span>
            </CheckboxField>
          ) : (
            <Skeleton height="2rem" width="100%" />
          )}
        </div>
        <div className="order-part-request-container">
          <div className="order-part-request-container-header">
            <b>PRN Info</b>
            {/* <button className="filled iconTextButton">
              <span className="pluse-icon">+</span> <span>Add PRN</span>
            </button> */}
          </div>
          <div className="order-part-request-container-list-header">
            <b>PRN</b>
            <b>WP</b>
            <b>AC</b>
            <b>TC/FND</b>
            <b className="qty">QTY</b>
          </div>
          <div className="order-part-request-container-list-body">
            {prnInfo?.map((prn, idx) => (
              <div
                key={`${item?.part_id}-${idx}`}
                className="order-prn-item-grey"
              >
                <p>
                  {context == "new_order"
                    ? prn.prn_id
                    : context == "order_management"
                    ? prn.id
                    : "--"}
                </p>
                <p>
                  {context == "new_order"
                    ? prn.work_package_number
                    : context == "order_management"
                    ? prn?.workPackageNumber
                    : "--"}
                </p>
                <p>
                  {context == "new_order"
                    ? prn.tail_number
                    : context == "order_management"
                    ? prn?.aircraftTailNumber
                    : "--"}
                </p>
                <p>
                  {context == "new_order"
                    ? prn.task_card_number
                    : context == "order_management"
                    ? prn?.partRequestDetailParts[0]?.taskCardNumber ||
                      prn?.partRequestDetailParts?.finding ||
                      "--"
                    : "--"}
                </p>
                {context == "new_order"
                  ? !prn.isOnEdition && <b>{prn.quantity_required}</b>
                  : context == "order_management"
                  ? !prn.isOnEdition && (
                      <b>{prn.partRequestDetailParts.length}</b>
                    )
                  : null}
                {prn.isOnEdition && (
                  <Input
                    style={{ gridColumn: "span 1" }}
                    onChange={(e) => changeValuePrn(e, idx)}
                    name="prn_quantity_required"
                    disableAutocomplete={true}
                    label={""}
                    isNumeric={true}
                    value={
                      context == "new_order"
                        ? prn.quantity_required
                        : context == "order_management"
                        ? prn.quantityOrder
                        : ""
                    }
                  ></Input>
                )}
                <div className="button-icons-action-order">
                  {!prn.isOnEdition && (
                    <i
                      style={{
                        opacity: disable || fromQuote ? ".5" : "1",
                        cursor: disable || fromQuote ? "not-allowed" : "pointer",
                      }}
                      className="icon-edit"
                      onClick={(e) => {
                        !disable && !fromQuote ? enableEdition(idx, item, true) : null;
                      }}
                    ></i>
                  )}
                  {prn.isOnEdition && (
                    <i
                      className="icon-new-save"
                      onClick={(e) => enableEdition(idx, item, false)}
                    ></i>
                  )}
                  <i
                    style={{
                      opacity: disable || fromQuote ? ".5" : "1",
                      cursor: disable || fromQuote ? "not-allowed" : "pointer",
                    }}
                    className="icon-delete-new"
                    onClick={(e) => {
                      !disable && !fromQuote ? onDeletePrn(idx, item) : null;
                    }}
                  ></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div>
        <div className="order-charges-disccounts">
          <h4>Charges & Discounts</h4>
          <div className="new-order-source-of-price">
            <div className="new-order-source-of-price-left">
              <b>Unit Price</b>
              <div style={{ width: "12vw" }}>
                {displayForm ? (
                  <Dropdowns
                    context={{
                      dropdownsData,
                      setDropdownsData,
                      setDropdownIds,
                      dropdownDefaultOptions,
                    }}
                    updateDropdown={updateDropdown}
                    resetDropdownsReload={resetDropdownsReload}
                    disabled={disable || fromQuote}
                    required={true}
                    key={123}
                    onOptionSelect={(value, data) =>
                      handleDropdownValue(value, dropdownNames[123], data)
                    }
                    hideRequiredLabel={true}
                    hideLabel={true}
                    showPagination={false}
                    data={dropdownsData.find((e) => e.id === 123)}
                    preSelectValue={selectionMode}
                  />
                ) : (
                  <Skeleton height="1.9rem" width="100%" />
                )}
              </div>
              {selectionMode === "Use Quote Price" && (
                <div className="unit-price-source-sub-selection">
                  <b>Quote N°</b>
                  {displayForm ? (
                    <Dropdowns
                      context={{
                        dropdownsData,
                        setDropdownsData,
                        setDropdownIds,
                        dropdownDefaultOptions,
                      }}
                      placeholder={true}
                      updateDropdown={updateDropdown}
                      resetDropdownsReload={resetDropdownsReload}
                      disabled={false}
                      key={124}
                      onOptionSelect={(value, data) =>
                        handleDropdownValue(value, dropdownNames[124], data)
                      }
                      hideRequiredLabel={true}
                      hideLabel={true}
                      showPagination={false}
                      data={dropdownsData.find((e) => e.id === 124)}
                    />
                  ) : (
                    <Skeleton height="1.9rem" width="100%" />
                  )}
                </div>
              )}
              {selectionMode === "Use Contract" && (
                <div className="unit-price-source-sub-selection">
                  <b>Contract</b>
                  {displayForm ? (
                    <Dropdowns
                      context={{
                        dropdownsData,
                        setDropdownsData,
                        setDropdownIds,
                        dropdownDefaultOptions,
                      }}
                      updateDropdown={updateDropdown}
                      resetDropdownsReload={resetDropdownsReload}
                      disabled={false}
                      placeholder={true}
                      key={124}
                      onOptionSelect={(value, data) =>
                        handleDropdownValue(value, dropdownNames[124], data)
                      }
                      hideRequiredLabel={true}
                      hideLabel={true}
                      showPagination={false}
                      data={dropdownsData.find((e) => e.id === 124)}
                    />
                  ) : (
                    <Skeleton height="1.9rem" width="100%" />
                  )}
                </div>
              )}
            </div>
            {selectionMode === "Use Quote Price" && (
              <div className="new-order-source-of-price-right">
                <b>Quotation Expiration Date</b>
                <b className="date-exp"> 05-06-2025</b>
              </div>
            )}
          </div>
          <div className="unit-cost-row">
            <b>Unit Cost</b>
            <div className="unit-cost-row-input">
              <Input
                style={{ gridColumn: "span 1" }}
                onChange={changeValue}
                name={
                  context == "new_order"
                    ? "unitCost"
                    : context == "order_management"
                    ? "unitPrice"
                    : ""
                }
                disableAutocomplete={true}
                disabled={disable || fromQuote}
                label={""}
                isNumeric={true}
                placeholder={"0.0"}
                value={
                  context == "new_order" ? values["unitCost"] : values.unitPrice
                }
              ></Input>
              <b>
                {context === "new_order" && generalInfo
                  ? generalInfo.currencyName
                  : context === "order_management"
                  ? currencyName
                  : "--"}
              </b>
            </div>
            <div className="sub-total-info-container">
              <b>Sub Total</b>
              <b className="price-blue">
                {new Intl.NumberFormat("en-US", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(subTotalCost)}{" "}
                {context === "new_order" && generalInfo
                  ? generalInfo.currencyName
                  : context === "order_management"
                  ? currencyName
                  : "--"}
              </b>
            </div>
          </div>
          <div className="normal-cost-row">
            <b>Discount</b>
            <div className="normal-cost-row-input">
              <Input
                style={{ maxWidth: "3rem" }}
                onChange={changeValue}
                name="discountPercentage"
                disableAutocomplete={true}
                // suffix={"%"}
                label={""}
                disabled={disable || fromQuote}
                placeholder={"%"}
                isNumeric={true}
                limit={100}
                value={
                  context == "new_order"
                    ? values["discountPercentage"]
                    : values["discountPercentage"]
                }
              ></Input>
              %
              <Input
                style={{ maxWidth: "5rem" }}
                onChange={changeValue}
                name="discount"
                disableAutocomplete={true}
                isNumeric={true}
                disabled={disable || fromQuote}
                placeholder={"0.0"}
                limit={subTotalCost}
                label={""}
                value={values["discount"]}
              ></Input>
              <b>
                {context === "new_order" && generalInfo
                  ? generalInfo.currencyName
                  : context === "order_management"
                  ? currencyName
                  : "--"}
              </b>
            </div>
          </div>
          <div className="normal-cost-row">
            <b>Duty</b>
            <div className="normal-cost-row-input">
              <Input
                style={{ width: "5rem" }}
                onChange={changeValue}
                name="duty"
                disableAutocomplete={true}
                isNumeric={true}
                disabled={disable}
                placeholder={"0.0"}
                label={""}
                value={context == "new_order" ? values["duty"] : values["duty"]}
              ></Input>
              <b>
                {context === "new_order" && generalInfo
                  ? generalInfo.currencyName
                  : context === "order_management"
                  ? currencyName
                  : "--"}
              </b>
            </div>
          </div>
          <div className="normal-cost-row">
            <b>Freight Cost</b>
            <div className="normal-cost-row-input">
              <Input
                style={{ width: "5rem" }}
                onChange={changeValue}
                name="freightCost"
                disableAutocomplete={true}
                disabled={disable}
                isNumeric={true}
                placeholder={"0.0"}
                label={""}
                value={
                  context == "new_order"
                    ? values["freightCost"]
                    : values["freightCost"]
                }
              ></Input>
              <b>
                {context === "new_order" && generalInfo
                  ? generalInfo.currencyName
                  : context === "order_management"
                  ? currencyName
                  : "--"}
              </b>
            </div>
          </div>
          <div className="normal-cost-row">
            <b>Tax</b>
            <div className="normal-cost-row-input">
              <Input
                style={{ maxWidth: "3rem" }}
                onChange={changeValue}
                name="taxPercentage"
                disableAutocomplete={true}
                label={""}
                disabled={disable || fromQuote}
                // suffix={"%"}
                // placeholder={"%"}
                isNumeric={true}
                limit={100}
                value={
                  context == "new_order"
                    ? values["taxPercentage"]
                    : values["taxPercentage"]
                }
              ></Input>
              %
              <Input
                style={{ maxWidth: "5rem" }}
                onChange={changeValue}
                name="tax"
                disabled={disable || fromQuote}
                disableAutocomplete={true}
                isNumeric={true}
                placeholder={"0.0"}
                label={""}
                value={context == "new_order" ? values["tax"] : values["tax"]}
              ></Input>
              <b>
                {context === "new_order" && generalInfo
                  ? generalInfo.currencyName
                  : context === "order_management"
                  ? currencyName
                  : "--"}
              </b>
            </div>
          </div>
        </div>
        <div className="order-charges-total-value">
          <div className="order-charges-total-value-row">
            <b>
              Total Cost <p> (after charges, and discounts)</p>
            </b>{" "}
            <b className="price-blue">
              {" "}
              {new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(totalCost)}{" "}
              {context === "new_order" && generalInfo
                ? generalInfo.currencyName
                : context === "order_management"
                ? currencyName
                : "--"}
            </b>
          </div>
        </div>
      </div>
      <div>
        <div className="order-logistics-delivery">
          <h4>Logistics & Delivery</h4>
          <div className="order-logistics-delivery-row">
            <BasicDatePicker
              style={{ width: "70%" }}
              label={"Est Delivery Date"}
              disabled={disable || fromQuote}
              isDateTime={false}
              isRequired={true}
              value={values["estDeliveryDate"]}
              name="estDeliveryDate"
              onChange={(newValue) => {
                changeValueDate(newValue, "estDeliveryDate");
              }}
              disablePastDates={true}
            ></BasicDatePicker>
            <Input
              disabled={disable}
              style={{ gridColumn: "span 1" }}
              onChange={changeValue}
              name="capitalExpenditure"
              disableAutocomplete={true}
              label={"Capital Expenditure"}
              value={values["capitalExpenditure"]}
            ></Input>
          </div>
          <div className="order-logistics-delivery-row">
            {displayForm ? (
              <Dropdowns
                context={{
                  dropdownsData,
                  setDropdownsData,
                  setDropdownIds,
                  dropdownDefaultOptions,
                }}
                updateDropdown={updateDropdown}
                resetDropdownsReload={resetDropdownsReload}
                disabled={disable}
                key={34}
                onOptionSelect={(value, data) =>
                  handleDropdownValue(value, dropdownNames[34], data)
                }
                error={errorState[dropdownNames[34]]}
                hideRequiredLabel={true}
                showPagination={false}
                data={dropdownsData.find((e) => e.id === 34)}
                preSelectValue={
                  context == "new_order"
                    ? defaults?.[dropdownNames[34]]
                    : context == "order_management"
                    ? item?.ownerId
                    : ""
                }
              />
            ) : (
              <Skeleton height="2rem" width="100%" />
            )}
          </div>
        </div>
        <div
          className="order-logistics-delivery"
          style={{ marginTop: "0.5rem" }}
        >
          <h4>Warranty Parameters</h4>
          <div className="order-logistics-delivery-row">
            <Input
              style={{ gridColumn: "span 1" }}
              onChange={changeValue}
              name="warrantyHours"
              disableAutocomplete={true}
              label={"Hours"}
              isNumeric={true}
              disabled={disable}
              value={values["warrantyHours"]}
            ></Input>
            <Input
              style={{ gridColumn: "span 1" }}
              onChange={changeValue}
              name="warrantyCycles"
              isNumeric={true}
              disableAutocomplete={true}
              label={"Cycles"}
              value={values["warrantyCycles"]}
              disabled={disable}
            ></Input>
            <Input
              style={{ gridColumn: "span 1" }}
              onChange={changeValue}
              name="warrantyCalendarDays"
              disableAutocomplete={true}
              isNumeric={true}
              label={"Calendar Days"}
              value={values["warrantyCalendarDays"]}
              disabled={disable}
            ></Input>
          </div>
          <div className="order-logistics-delivery-row">
            <Input
              style={{ gridColumn: "span 1" }}
              onChange={changeValue}
              name="warrantyAircraftDays"
              isNumeric={true}
              disableAutocomplete={true}
              label={"Aircraft Days"}
              value={values["warrantyAircraftDays"]}
              disabled={disable}
            ></Input>
            <CheckboxField
              disabled={disable}
              outlined
              checked={values.warrantyLatest}
              onChange={(checked) => handleSelectAll(checked, "warrantyLatest")}
            >
              <span>Latest Checkbox</span>
            </CheckboxField>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailInfo;
